:host {
    display: block;
    max-width: 100%;
  }
  
  :host(.t-space-30) {
    margin-top: 1.875rem;
  }
  
  .reset {
    font-size: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
    color: inherit !important;
  }
  
  .p {
    margin: 0;
    padding: 0;
    font-family: var(--primary-font);
    font-weight: var(--font-weight-normal);
    font-style: var(--font-weight-normal);
    color: var(--color-nero);
  }
  
  @include supportedColors();
  @include supportedTypography();
  
  ::slotted(a) {
    text-decoration: underline;
    text-transform: uppercase;
  }
  
  ::slotted(.normalcaseLink) {
    text-transform: none;
  }
  
  ::slotted(.semibold) {
    font-weight: var(--font-weight-semibold);
  }
  
  ::slotted(lilu-link) {
    display: inline-block;
  }
  